import { studySongActionTypes } from './Constants';

const initialState = {
	loading: true,
	data: null,
	error: false,
	favoriteSongLoading: false,
};

export default function studySongReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data, isFavorite } = payload || {};

	switch (type) {
		case studySongActionTypes.GENERATE_SONG_REQUEST:
			return {
				...state,
				loading: true,
				error: false,
				data,
			};

		case studySongActionTypes.GENERATE_SONG_SUCCESS:
		case studySongActionTypes.GET_SONG_DETAILS_SUCCESS:
			return {
				...state,
				loading: false,
				data,
			};

		case studySongActionTypes.GENERATE_SONG_ERROR:
			return {
				...state,
				loading: false,
				error: true,
			};

		case studySongActionTypes.GET_SONG_DETAILS_REQUEST:
			return {
				...state,
				loading: true,
			};

		case studySongActionTypes.GET_SONG_DETAILS_ERROR:
			return {
				...state,
				loading: false,
			};

		case studySongActionTypes.FAVORITE_UNFAVORITE_SONG_REQUEST:
			return {
				...state,
				favoriteSongLoading: true,
			};

		case studySongActionTypes.FAVORITE_UNFAVORITE_SONG_SUCCESS:
			return {
				...state,
				favoriteSongLoading: false,
				data: {
					...state.data,
					is_favorite: isFavorite,
				},
			};

		case studySongActionTypes.FAVORITE_UNFAVORITE_SONG_ERROR:
			return {
				...state,
				favoriteSongLoading: false,
			};

		case studySongActionTypes.CLEAR_AI_SONG_STATE:
			return initialState;

		default:
			return state;
	}
}
